export default __webpack_public_path__ + "static/media/email.8952cfe5.svg";